import React from 'react';
import { Box, useMediaQuery, useTheme, TextField } from '@material-ui/core';
import { useIntl } from 'react-intl';
import { StepButtonBar } from '../EditLegalListWizard/StepButtonBar';
import { StepProps } from './types';
import UpdateConnectionInfo from './UpdateConnectionInfo';

interface Step5EditCompanyUnitNameProps extends StepProps {
  unitName: string;
  currentStepName: string;
  updateConnectionInfo: any;
  setUpdateConnectionInfo: (info: any) => void;
}

const Step5EditCompanyUnitName = ({
  onNext,
  onBack,
  onCancel,
  isFirstStep,
  unitName,
  currentStepName,
    updateConnectionInfo,
  setUpdateConnectionInfo,
}: Step5EditCompanyUnitNameProps) => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
const paperPadding = isMobile ? theme.spacing(3) : theme.spacing(8);
  return (
        <div style={{ width: '100%' }}>
      <div
        style={{
          display: 'flex',
          width: '100%',
          gap: '10px',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: 'stretch',
        }}
      >
        <div
          style={{
            width: isMobile ? '100%' : 'calc(50% - 5px)',
            flexShrink: 0,
            padding: paperPadding,
            backgroundColor: '#f7f0f1',
            display: 'flex',
            flexDirection: 'column',
            boxSizing: 'border-box',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '350px',
          }}
        >
          <Box style={{ maxWidth: '320px', width: '100%' }}>
            <TextField
          placeholder={formatMessage({ id: 'form.name' })}
          value={unitName}
          // disabled
          fullWidth
          InputProps={{
            readOnly: true,
            style: { textAlign: 'center' },
          }}
        />
          </Box>
        </div>
        <UpdateConnectionInfo
          updateConnectionInfo={updateConnectionInfo}
          currentStepName={currentStepName}
          onUpdate={setUpdateConnectionInfo}
        />
      </div>

      <Box>
            <StepButtonBar
          onCancel={onCancel}
          onBack={onBack}
          onNext={onNext}
          nextLabel="form.next"
          formatMessage={formatMessage}
          showBack={!isFirstStep}
        />
      </Box>
    </div>
  );
};

export default Step5EditCompanyUnitName;
